export default {
  pagination_first: 'Début',
  pagination_last: 'Fin'
};
